import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface StockErrorDialogProps {
  open: boolean;
  errors: string[];
  onClose: () => void;
}

export function StockErrorDialog({
  open,
  errors,
  onClose,
}: StockErrorDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          borderTop: "4px solid",
          borderColor: "error.main",
        },
      }}
    >
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}
      >
        <ErrorOutlineIcon color="error" />
        <Typography variant="h6" component="span" fontWeight={600}>
          Stock insuficiente
        </Typography>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Los siguientes productos no tienen stock suficiente para completar el
          pedido:
        </Typography>

        <Box
          sx={{
            backgroundColor: "error.50",
            border: "1px solid",
            borderColor: "error.light",
            borderRadius: 1,
            px: 1,
          }}
        >
          <List dense disablePadding>
            {errors.map((error, index) => (
              <ListItem key={index} disableGutters sx={{ py: 0.75 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <WarningAmberRoundedIcon
                    fontSize="small"
                    sx={{ color: "error.main" }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={error}
                  primaryTypographyProps={{
                    variant: "body2",
                    color: "error.dark",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" color="error" onClick={onClose}>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
